export default __webpack_public_path__ + "static/media/arrowDown.3f40cd35.gif";